import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppGlobals } from '@app/app.global';

import { AuthService } from '@core/services';

@Injectable()
export class NoAuthGuard implements CanActivate {
    loading = false;

    constructor(private router: Router,
        private authService: AuthService,
        private appGlobals: AppGlobals) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService.isLoggedIn || !this.authService.user.isOnboarded) {
            return true;
        } else {
            // logged in so redirect to appropriate home page based on role
            const defaultPath = this.appGlobals.getDefaultLandingPath(this.authService.user);
            this.router.navigate(defaultPath);
            return false;
        }
    }
}